<template>
  <div v-if="activeItem" class="space-y-3 pr-3">
    <uiTextarea
      v-model="activeItem.title"
      label="Заголовок"
    />

    <uiTextarea
      v-model="activeItem.description"
      label="Описание"
    />

    <div class="flex">
      <uiColorPicker
        v-model="activeItem.textColor"
        label="Цвет текста"
      />
      <uiColorPicker
        v-model="activeItem.gradient.to"
        label="Цвет градиента"
      />
    </div>

    <div class="flex space-x-6">
      <div class="flex flex-1 space-x-2">
        <label class="flex flex-1 relative">
          <uiInput
            :value="getURLPathname(activeItem.image)"
            class="flex-1"
            label="Картинка"
            readonly
          />
          <input
            type="file"
            accept="image/*"
            class="absolute w-full h-full left-0 top-0 opacity-0 cursor-pointer"
            @change="preUploadFile(activeItem, $event)"
          />
        </label>

        <div v-if="activeItem.image" class="pt-6 flex items-center space-x-2">
          <a
            :href="activeItem.image"
            target="_blank"
            class="flex text-gray-600 cursor-pointer"
          >
            <Icon icon="ph:link" width="16" />
          </a>

          <div class="flex text-red-500 cursor-pointer" @click="activeItem.image = ''">
            <Icon icon="ph:trash" width="16" />
          </div>
        </div>
      </div>

      <p class="self-center m-0 mt-4 text-sm text-gray-500">или</p>

      <uiInput
        v-model="activeItem.emoji"
        label="Эмодзи"
        class="flex-1"
      />
    </div>

    <uiDropdown
      v-if="visibleKind"
      label="Действие по клику"
      :clearSearchOnSelect="true"
      :options="itemKinds"
      :value="itemKinds.find(k => k.value === activeItem.kind)"
      @input="activeItem.kind = $event.value"
    />

    <template v-if="activeItem.kind === 'link'">
      <div class="flex items-center space-x-2">
        <uiDropdown
          label="Статья"
          :clearSearchOnSelect="true"
          :options="articlesOptions"
          :value="articlesOptions.find(a => a.value === activeItem.link)"
          @input="activeItem.link = $event.value"
          class="flex-1"
        />

        <div v-if="activeItem.link" class="pt-6 flex items-center">
          <a
            :href="activeItem.link"
            target="_blank"
            class="flex text-gray-600 cursor-pointer"
          >
            <Icon icon="ph:link" width="16" />
          </a>
        </div>
      </div>
    </template>

    <template v-if="activeItem.kind === 'page'">
      <div class="flex items-center space-x-2">
        <uiDropdown
          label="Страница"
          :clearSearchOnSelect="true"
          :options="pagesOptions"
          :value="pagesOptions.find(p => p.value === activeItem.page)"
          @input="activeItem.page = $event.value"
          class="flex-1"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { computed } from 'vue'
import Draggable from 'vuedraggable'
import { useArticles } from '../composables/articles'
import { usePages } from '../composables/pages'
import { mapToList } from '@/utils/select'

function getURLPathname(url) {
  if (!url) return url

  try {
    const { pathname } = new URL(url)
    const [name] = (pathname || '').split('/').reverse()

    return name || url
  } catch (e) {
    return url
  }
}

export default {
  components: {
    Draggable,
  },
  props: {
    activeItem: {
      type: Object,
      default: null
    },
    visibleKind: {
      type: Boolean,
      default: true
    }
  },
  setup() {
    const itemKinds = mapToList({
      'link': 'Переход на статью',
      'page': 'Открытие страницы',
    })

    const { articles } = useArticles()
    const articlesOptions = computed(() => articles.value.map((a) => ({
      value: a.url,
      label: a.documentTitle
    })))

    const { pages } = usePages()
    const pagesOptions = computed(() => pages.value.map((p) => ({
      value: p.id,
      label: p.title
    })))

    function preUploadFile(item, e) {
      const [file] = e?.target?.files ?? []
      if (!file) return

      const url = URL.createObjectURL(file)

      const img = new Image()
      img.src = url
      img.onload = () => {
        item.image = url
        item.imageFile = file
      }
    }

    return {
      getURLPathname,
      itemKinds,
      articles,
      articlesOptions,
      pages,
      preUploadFile,
      pagesOptions,
    }
  }
}
</script>

<style lang="postcss">
.article-group.sortable-ghost {
  @apply opacity-20;
}
</style>